export default __webpack_public_path__ + "static/media/earth-restoration-logo.ec543b6c.png";